import { AxiosError } from 'axios'
import { axiosDelete } from 'shared/api/axios'
import displayGenError from 'shared/utils/displayGenError'
import Entity from '../types/Entity'
import displayError from 'shared/utils/displayError'
import nestedSort from './nestedSort'

interface handleExcludeRowProps {
  row: Entity
  url: string
  relationalFieldName: string
  includedRows: Array<Entity>
  excludedRows: Array<Entity>
  setDisableActions: Function
  setIncludedRows: Function
  setExcludedRows: Function
  setShowOverlay: Function
  onRemoveItem?: (entity: Entity) => boolean
}

const handleExcludeRow = async (props: handleExcludeRowProps): Promise<boolean> => {
  const {
    row,
    url,
    relationalFieldName,
    includedRows,
    excludedRows,
    setDisableActions,
    setIncludedRows,
    setExcludedRows,
    setShowOverlay,
    onRemoveItem,
  } = props

  if (onRemoveItem !== undefined) {
    const result: boolean = onRemoveItem(row)
    if (result === false) {
      return false
    }

    setIncludedRows((prevState) => prevState.filter((r) => r.id !== row.id))

    const rowExcluded: Entity = { ...row }
    rowExcluded.order = null
    delete rowExcluded.greyOutIncluded
    delete rowExcluded.nestedItems

    setExcludedRows((prevState) =>
      nestedSort(
        [
          ...prevState.filter(
            (r) => r[props.relationalFieldName] !== rowExcluded[props.relationalFieldName],
          ),
          rowExcluded,
        ],
        includedRows.map((i) => ({
          ...i,
        })),
        props.relationalFieldName,
      ),
    )

    return true
  }

  setDisableActions(true)

  const catchFunc = (err: AxiosError) => {
    const message: string = err.response?.data?.message ?? 'An error has occurred.'
    displayError({
      errorMessage: message,
      setShowOverlay,
    })
  }

  const deletedOrder = row.order ?? 0
  const response = await axiosDelete(`${url}/${row.id}`, {}, catchFunc)

  setDisableActions(false)

  if (response.status === 204) {
    setIncludedRows((prevState) =>
      prevState
        .filter((r) => r.id !== row.id)
        .map((r) => ({
          ...r,
          order:
            Number.isInteger(r.order) && r.order > deletedOrder
              ? r.order - 1
              : r.order,
        })),
    )

    const rowExcluded: Entity = { ...row }
    rowExcluded.order = null
    delete rowExcluded.greyOutIncluded
    delete rowExcluded.nestedItems

    setExcludedRows((prevState) =>
      nestedSort(
        [
          ...prevState.filter(
            (r) => r[relationalFieldName] !== rowExcluded[relationalFieldName],
          ),
          rowExcluded,
        ],
        includedRows.map((i) => ({
          ...i,
        })),
        props.relationalFieldName,
      ),
    )

    return true
  } else {
    displayGenError({ setShowOverlay })
  }

  return false
}

export default handleExcludeRow